import React, { PureComponent } from "react";
// import ReactTooltip from "react-tooltip";

import styles from "./Item.local.scss";
import {
  formatOrganizationTitle,
  formatUen,
  resolveOrganizationState,
  abbreviateNumber
} from "Utils";
import { CHECKBOX_CHECKED, CHECKBOX_UNCHECKED } from "Config";
import Percentage from "../Common/Percentage/Percentage";
import _ from "i18n";
import {
  AttachmentIcon,
  CalendarIcon,
  ICONS,
  SvgIcon,
  TrelloIcon
} from "../Common/Icons";
import classnames from "classnames";
import CheckBox from "./CheckBox";
import DropDownActionsList from "../Common/DropDown/DropDownActionsList";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { folderRolesCollaborator } from "../../utils";
import { TiWarningOutline } from "react-icons/ti";

class Item extends PureComponent {
  /*  handleClickItem = (client, dashboard) => {
    this.props.dispatch(push(`/fiche-client/${client.uen}`));
  };*/

  renderClient(dataState) {
    let {
      // status,
      organization,
      presentation, // keyIndicators,
      financialRatios,
      stats,
      id,
      roleCollab,
      annexes,
      selected,
      accountingDates,
      startDate,
      loggedAs,
      userId,
      spaceAs,
      synchro,
      __auth,
      year
    } = this.props;

    __auth = __auth || [];
    return (
      <div
        key=""
        className={`row ${styles.list_item} border-${dataState.colorClass}`}
        //onClick={() => this.handleClickItem(organization, dashboard)}
      >
        <div className={`medium-1 ${styles.check}`}>
          <CheckBox
            state={selected ? CHECKBOX_CHECKED : CHECKBOX_UNCHECKED}
            handleSelectCheckbox={() => this.props.handleSelectClient(id)}
          />
        </div>

        <div
          className={`medium-4 ${styles.list_item__header}`}
          style={{ marginLeft: "-5%", marginRight: "2%" }}
        >
          <div className={styles.list_item__first_header}>
            <div className={styles.list_item__header_title}>
              {formatOrganizationTitle(
                organization.name,
                organization.legalForm
              )}
            </div>
            <div className={styles.list_item__sub_header}>
              {organization.uen
                ? formatUen(organization.uen)
                : _("undefinedVAT")}
            </div>
            {organization.groupDescription && (
              <div className={styles.list_item__sub_tag}>
                {`${_("CRM")} : ${organization.groupDescription}`}
              </div>
            )}
          </div>
          {/* <div className={styles.list_item__sub_header_2}>
            {dashboard.label}
          </div>*/}
          {((loggedAs === "MANAGER" && spaceAs === "COLLABORATOR") ||
            loggedAs === "COLLABORATOR") &&
          synchro ? (
            <div className={styles.role_collaborator}>
              {folderRolesCollaborator(roleCollab, userId)}
            </div>
          ) : (
            ""
          )}
          <div className={styles.list__row_groups_cell_wrapper}>
            <div className={classnames(styles.groups_block_position)}>
              {stats.balancesImported && (
                <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                  <span>
                    {_("lastImport")} : {stats.lastBalanceImportedYear}
                  </span>
                </span>
              )}
              <span className={styles.list__row_group_cell_tag}>
                {stats.balancesImported ? stats.balancesImported : 0}{" "}
                {_("importedBalances")}
              </span>
              <span className={styles.list__row_group_cell_tag}>
                {stats.configuredExercises ? stats.configuredExercises : 0}{" "}
                {_("configuredExercises")}
              </span>
            </div>
          </div>
        </div>

        <div className={`medium-1 ${styles.list_item__key}`}>
          <div
            data-for={`profitability__${organization.uen}`}
            data-tip={"Net assets"}
          >
            <SvgIcon icon={ICONS.Euro} className={styles.list_item_icon} />
            <span className={styles.list_item_value}>
              {financialRatios
                ? abbreviateNumber(financialRatios.profitabilityRatio)
                : "-"}
            </span>
            {financialRatios ? (
              <span className={styles.percentage_diff}>
                <Percentage
                  percentage={financialRatios.profitabilityRatioPercentage}
                />
              </span>
            ) : (
              ""
            )}
            <div>{_("profitability")}</div>
            {/*<ReactTooltip*/}
            {/*  id={`profitability__${organization.uen}`}*/}
            {/*  type="dark"*/}
            {/*  place="bottom"*/}
            {/*/>*/}
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div
            data-for={`solvency__${organization.uen}`}
            data-tip={"Degree of financial independence"}
          >
            <SvgIcon icon={ICONS.BriefCase} className={styles.list_item_icon} />
            <span className={styles.list_item_value}>
              {financialRatios ? financialRatios.solvencyRatio : "-"}
            </span>
            {financialRatios ? (
              <span className={styles.percentage_diff}>
                <Percentage
                  percentage={financialRatios.solvencyRatioPercentage}
                />
              </span>
            ) : (
              ""
            )}
            <div>{_("solvency")}</div>
            {/*<ReactTooltip*/}
            {/*  id={`solvency__${organization.uen}`}*/}
            {/*  type="dark"*/}
            {/*  place="bottom"*/}
            {/*/>*/}
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div
            data-for={`liquidity__${organization.uen}`}
            data-tip={"Current ratio"}
          >
            <SvgIcon icon={ICONS.BriefCase} className={styles.list_item_icon} />
            <span className={styles.list_item_value}>
              {financialRatios ? financialRatios.liquidityRatio : "-"}
            </span>
            {financialRatios ? (
              <span className={styles.percentage_diff}>
                <Percentage
                  percentage={financialRatios.liquidityRatioPercentage}
                />
              </span>
            ) : (
              ""
            )}
            <div>{_("liquidity")}</div>
            {/*<ReactTooltip*/}
            {/*  id={`liquidity__${organization.uen}`}*/}
            {/*  type="dark"*/}
            {/*  place="bottom"*/}
            {/*/>*/}
          </div>
        </div>

        <div className={`medium-3 ${styles.presentation}`}>
          <div className={styles.presentation_img}>
            <div className={styles.title}>
              <span className={styles.title_bar} />
              {_("presentation")} {year}
            </div>
          </div>
          <div className={styles.presentation_items_info}>
            <div>
              {presentation && presentation.isPrepared ? (
                <div>
                  <TrelloIcon fill={"#06D9B1"} size={12} />
                  <span className={styles.presentation_items_prepared}>
                    {_("prepared")}
                  </span>
                </div>
              ) : (
                <div>
                  <TrelloIcon fill={"#f9626d"} size={12} />
                  <span className={styles.presentation_items_notprepared}>
                    {_("notPrepared")}
                  </span>
                </div>
              )}
            </div>
            <div className={styles.presentation_item}>
              <CalendarIcon fill={"#29394D"} size={12} />
              {presentation && presentation.date ? (
                <span>
                  {presentation.isPresented
                    ? _("presentedThe")
                    : _("toPresenteThe")}{" "}
                  {presentation.date}
                </span>
              ) : (
                <span>{_("undefinedDate")}</span>
              )}
            </div>
            <div className={styles.presentation_item}>
              {annexes == 0 ? (
                <div>
                  <TiWarningOutline size={12} />
                  <span>{_("noAnnexes")}</span>
                </div>
              ) : (
                <div>
                  <AttachmentIcon fill={"#29394D"} size={12} />
                  <span>{_("withAnnexe")}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="medium-1">
          <div className={styles.list_item__status}>
            <i className={`bg-${dataState.colorClass}`} />{" "}
            <span>{_(dataState.status)}</span>
          </div>

          <div className={styles.list_item__actions}>
            {/* {__auth.includes("access_dashboard") ? ( */}
            <Tooltip
              placement="bottom"
              title={_("clientForm")}
              mouseLeaveDelay={0}
            >
              <div
                onClick={e => {
                  e.stopPropagation();
                  this.props.handleDisplayFicheClient(organization);
                }}
                className={styles.disable_action}
              >
                <SvgIcon icon={ICONS.HOME} />
              </div>
            </Tooltip>

            {/* ) : (
              ""
            )} */}
            {__auth.includes("import_balance") ? (
              <Tooltip
                placement="bottom"
                title={_("configuration")}
                mouseLeaveDelay={0}
              >
                <div
                  onClick={e => {
                    e.stopPropagation();
                    this.props.handleShowModal({
                      id,
                      ...organization,
                      accountingDates,
                      startDate
                    });
                  }}
                >
                  <SvgIcon icon={ICONS.SETTING} className={"icon_setting"} />
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            <DropDownActionsList
              visible={true}
              shortId={organization.uen}
              renderDropDownMenuActions={() =>
                this.renderDropDownMenuActions(organization.uen)
              }
            />
          </div>
        </div>
      </div>
    );
  }

  renderExternal(dataState) {
    let { status, organization } = this.props;

    return (
      <div
        key=""
        className={`row ${styles.list_item} border-${dataState.colorClass}`}
      >
        <div className="medium-5">
          <div className={styles.list_item__header}>
            {formatOrganizationTitle(organization.name)}
          </div>
          <div className={styles.list_item__sub_header}>
            {organization.uen ? formatUen(organization.uen) : _("undefinedVAT")}
          </div>

          <div className={styles.list_item__sub_header} />
        </div>
        <div className="medium-3" />

        <div className={`medium-1 ${styles.list_item__count}`} />

        <div className={`medium-1 ${styles.list_item__count}`} />

        <div className="medium-2">
          <div className={styles.list_item__status}>
            <i className={`bg-${dataState.colorClass}`} /> {_(dataState.status)}
          </div>
          {"EXTERNAL" === status ? (
            <div className={styles.list_item__actions}>
              <DropDownActionsList
                visible={true}
                shortId={organization.uen}
                renderDropDownMenuActions={() =>
                  this.renderDropDownMenuActions(organization.uen)
                }
              />
            </div>
          ) : (
            <div className={styles.list_item__actions} />
          )}
        </div>
      </div>
    );
  }

  renderDropDownMenuActions = organizationUen => {
    return (
      <ul className="menu drop-down-option__left default drop-down-option--show">
        <li>
          <a
            className={""}
            href={`https://data.be/en/company/${organizationUen}`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/data_be-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            Data.be
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=fr&nummer=${organizationUen}&actionLu=Recherche`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/crossroads_bank_for_companies-logo.png"}
              alt={""}
              style={{ height: 15, marginLeft: -6 }}
            />
            Crossroads Bank for Companies
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`http://www.ejustice.just.fgov.be/cgi_tsv/tsv_rech.pl?language=fr&btw=${organizationUen}&liste=Liste`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/spf_justice-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            SPF Justice
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://consult.cbso.nbb.be/consult-enterprise/${organizationUen}`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/national_bank-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            National Bank
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://www.socialsecurity.be/app014/wrep/rep_gp.do?language=fr&REP_KEY_VALUE=${organizationUen}&ACCESS_TYPE=0&ACTION=1&REP_KEY_TYPE=12&REP_LIMIT_DATE=`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/social_security-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            Social Security
          </a>
        </li>
      </ul>
    );
  };

  render() {
    let { status, globalState } = this.props;
    let dataState = resolveOrganizationState(status, globalState);

    return "EXTERNAL" !== dataState.status
      ? this.renderClient(dataState)
      : this.renderExternal(dataState);
  }
}

export default connect()(Item);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/Item.js